import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BASE_URL } from '../components/SEO';

const Termos: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <Helmet>
        <title>Termos de Uso | eFortiPsi - Psicóloga Eliane Forti Fernandes</title>
        <meta name="description" content="Termos de uso do site eFortiPsi, da psicóloga Eliane Forti Fernandes (CRP 06/216637), em Caieiras - SP." />
        <link rel="canonical" href={`${BASE_URL}/termos`} />
      </Helmet>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold text-[#2a3c5c] mb-6">
          Termos de Uso – Eforti Psi
        </h1>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">1. Introdução</h2>
          <p className="text-gray-700 mb-4">
            Os presentes Termos de Uso regulam a utilização do site www.efortipsi.com.br e os serviços oferecidos pela Eforti Psi, representada por Eliane Forti Fernandes, psicóloga devidamente registrada no Conselho Regional de Psicologia de São Paulo (CRP-SP).
          </p>
          <p className="text-gray-700 mb-4">
            Ao acessar este site, o usuário declara ter lido, compreendido e concordado com as disposições aqui estabelecidas.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">2. Serviços Oferecidos</h2>
          <p className="text-gray-700 mb-4">
            A Eforti Psi oferece serviços de psicoterapia e suporte psicológico, incluindo:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>Psicoterapia individual (presencial e online)</li>
            <li>Psicoterapia para casais e famílias</li>
            <li>Atendimento psicológico para crianças e adolescentes</li>
            <li>Intervenção em crises emocionais</li>
            <li>Orientação e suporte a pais e cuidadores</li>
          </ul>
          <p className="text-gray-700 mb-4">
            As consultas psicológicas seguem todas as diretrizes do CRP-SP e a legislação vigente no Brasil.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">3. Agendamento e Atendimento</h2>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>O agendamento de consultas deve ser realizado pelo e-mail contato@efortipsi.com.br ou via WhatsApp</li>
            <li>O horário das consultas será previamente combinado e confirmado pela equipe da Eforti Psi</li>
            <li>O não comparecimento sem aviso prévio pode implicar cobrança da sessão, conforme política de cancelamento</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">4. Uso Adequado do Site</h2>
          <p className="text-gray-700 mb-4">
            O usuário compromete-se a:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>Utilizar o site de forma ética, respeitosa e em conformidade com a legislação vigente</li>
            <li>Não divulgar informações falsas, ofensivas ou que violem direitos de terceiros</li>
            <li>Não reproduzir conteúdos do site sem autorização</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">5. Sigilo Profissional e Ética Psicológica</h2>
          <p className="text-gray-700 mb-4">
            O serviço de psicoterapia prestado pela Eforti Psi segue o Código de Ética Profissional do Psicólogo.
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>Todas as informações compartilhadas nas sessões são sigilosas</li>
            <li>Nenhuma informação do paciente será divulgada sem seu consentimento, salvo exigência legal</li>
            <li>O atendimento psicológico online segue as regulamentações do CRP-SP e as diretrizes do Conselho Federal de Psicologia (CFP)</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">6. Responsabilidades e Isenções</h2>
          <p className="text-gray-700 mb-4">
            A Eforti Psi não se responsabiliza por:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>Decisões tomadas pelo usuário com base em informações do site</li>
            <li>Problemas técnicos que impeçam o acesso ao site</li>
            <li>Conteúdos de terceiros acessados por meio de links externos</li>
          </ul>
          <p className="text-gray-700 mb-4">
            O serviço de psicoterapia não substitui tratamentos médicos e psiquiátricos.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">7. Propriedade Intelectual</h2>
          <p className="text-gray-700 mb-4">
            Todos os textos, imagens e demais conteúdos deste site são de propriedade da Eforti Psi e protegidos por direitos autorais. Qualquer reprodução não autorizada está sujeita a penalidades legais.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">8. Alterações nos Termos de Uso</h2>
          <p className="text-gray-700 mb-4">
            A Eforti Psi reserva-se o direito de modificar estes Termos de Uso a qualquer momento.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#2a3c5c] mb-4">9. Contato</h2>
          <p className="text-gray-700">
            Para dúvidas ou solicitações sobre os Termos de Uso, entre em contato:<br />
            📩 E-mail: contato@efortipsi.com.br<br />
            📲 Agendamentos: contato@efortipsi.com.br ou WhatsApp
          </p>
        </section>
      </div>
    </div>
  );
};

export default Termos;
